import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  private appConfig: any;

  constructor(private http: HttpClient) {}

  loadAppConfig() {
    return this.http
      .get("/assets/config.json")
      .toPromise()
      .then((data) => {
        this.appConfig = data;
      });
  }

  get crmApiUrl() {
    if (!this.appConfig) {
      throw Error("Config file not loaded!");
    }
    return this.appConfig.crmApiUrl;
  }

  get buildiumApiUrl() {
    if (!this.appConfig) {
      throw Error("Config file not loaded!");
    }
    return this.appConfig.buildiumApiUrl;
  }

  get templateAccountNumber() {
    if (!this.appConfig) {
      throw Error("Config file not loaded!");
    }
    return this.appConfig.templateAccountNumber;
  }

  get crmAPIUser() {
    if (!this.appConfig) {
      throw Error("Config file not loaded!");
    }
    return this.appConfig.crmAPIUser;
  }

  get crmAPIPassword() {
    if (!this.appConfig) {
      throw Error("Config file not loaded!");
    }
    return this.appConfig.crmAPIPassword;
  }
}
